export const DESCRIPTION_LENGTH = 150;
export const CATEGORY = "category";
export const CATEGORY_VIEW = "View";
/**
 * Categories to hide from the live site (shop grid, category pages, menus, related products, etc).
 * Values must match the product.category entries as stored in Firestore (e.g. "Night", "View").
 * To bring a category back online, remove it from this list and redeploy.
 */
export const HIDDEN_CATEGORIES = ["Night", "View"];
export const SEARCH = "search";
export const PAGINATION = "pagination";
export const PRICEFILTER = "priceFilter";
export const DEFAULT = "default";
export const PRODUCT_PLACEHOLDER_SRC =
  process.env.REACT_APP_FIREBASE_STORAGE_BASE_URL +
  "/o/global%2Fplaceholder.jpg?alt=media";
export const PRODUCT_PLACEHOLDER_LOCAL_SRC =
  "/assets/img/product/placeholder.webp";
export const CATEGORY_PLACEHOLDER_SRC = "assets/img/categories/placeholder.jpg";
export const RELATED_PRODUCTS_IMG_WIDTH = 250;
